import { IMultiSelectOption, IMultiSelectTexts, IMultiSelectSettings, } from 'ngx-bootstrap-multiselect';
import Office from 'app/models/office';
import { Contact } from 'app/models/contact';
import { capitalize } from './formatters';

export function handleIMultiSelectTexts(singular: string, config?: { definedPlural?: string, defaultTitle?: string, allSelected?:string }): IMultiSelectTexts {
  // if no custom configs. set customValues to empty obeject, this allows destructured consts to become undefined on line below
  const customValues = config || {}
  const { allSelected, definedPlural, defaultTitle } = customValues

  const plural = definedPlural || singular + 's';
  const capitalizedPlural = capitalize(plural)

  return {
    checked: `${singular} selected`,
    checkedPlural: `${plural} selected`,
    defaultTitle: defaultTitle || `All ${capitalizedPlural}`,
    allSelected: allSelected || `All ${capitalizedPlural}`
  };
}

function isDefined(value: any) {
  return value !== undefined && value !== null
}

export function handleIMultiSelectSettings(settings?: Partial<IMultiSelectSettings>): IMultiSelectSettings {
  const customSettings = settings || {}
  const {
    enableSearch,
    closeOnSelect,
    showCheckAll,
    showUncheckAll,
    buttonClasses,
    dynamicTitleMaxItems,
    displayAllSelectedText,
    closeOnClickOutside,
    selectionLimit,
    autoUnselect,
    pullRight,
    maxHeight
  } = customSettings


  // it would be cooler to use new nullish coalleser here (??), but the build doesnt recognize the syntax atm 4/2021
  return {
    enableSearch: isDefined(enableSearch) ? enableSearch : false,
    closeOnSelect: isDefined(closeOnSelect) ? closeOnSelect : false,
    showCheckAll: isDefined(showCheckAll) ? showCheckAll : false,
    showUncheckAll: isDefined(showUncheckAll) ? showUncheckAll : false,
    buttonClasses: isDefined(buttonClasses) ? buttonClasses : 'btn btn-multiselect btn-block',
    dynamicTitleMaxItems: isDefined(dynamicTitleMaxItems) ? dynamicTitleMaxItems : 1,
    displayAllSelectedText: isDefined(displayAllSelectedText) ? displayAllSelectedText : true,
    closeOnClickOutside: isDefined(closeOnClickOutside) ? closeOnClickOutside : true,
    selectionLimit: isDefined(selectionLimit) ? selectionLimit : 0,
    autoUnselect: isDefined(autoUnselect) ? autoUnselect : false,
    pullRight: isDefined(pullRight) ? pullRight : false,
    maxHeight: isDefined(maxHeight) ? maxHeight : '300px'
  }
}

export const officeReducer = (office: Office) => {
  return { id: office.id, name: office.name }
}

export const contactReducer = (contact: Contact) => {
  return { id: contact.id, name: `${contact.last_name}, ${contact.first_name} (${contact.contact_type_name})` };
};
